<div class="sg_container" *ngIf="sg">
  <div class="text_bold">
    {{sg.id}}
    <span *ngIf="sg.name">
      ({{sg.name}})
    </span>
  </div>
</div>